import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import EditAdmin from "../../features/EditAdmin";

function EditAdminPage() {
  return (
    <BaseLayout>
      <EditAdmin />
    </BaseLayout>
  );
}

export default EditAdminPage;
